import { ISection } from '@sdk/contracts';
import { Typography } from 'antd';
import React from 'react';
import { useTheme } from 'styled-components';

import { Icon } from '@/components/Icon';
import { useMutateSection, useProfile } from '@/store';

type Props = {
  section: ISection;
};

const { Text } = Typography;

export const SectionName: React.FC<Props> = ({ section }) => {
  const { name } = section;
  const { colors } = useTheme();
  const { updateSection } = useMutateSection();
  const {
    roleCheck: { isManager, isTeacher }
  } = useProfile();

  const canEditName = isManager || isTeacher;

  const handleUpdateSection = (newSectionName: string) => {
    if (newSectionName && newSectionName !== name) {
      updateSection({ ...section, name: newSectionName });
    }
  };

  return (
    <Text
      color={colors.green6}
      editable={
        canEditName && { icon: <Icon i="Edit" color="green6" />, onChange: handleUpdateSection }
      }>
      {name}
    </Text>
  );
};
